import { createContext, useState } from "react";

const UserDataContext = createContext();

const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState();
  const [userDataLoading, setUserDataLoading] = useState(true);

  return (
    <UserDataContext.Provider
      value={{
        userData,
        setUserData,
        userDataLoading,
        setUserDataLoading,
      }}
    >
      {children}
    </UserDataContext.Provider>
  );
};

export { UserDataContext, UserDataProvider };
